// Please do not over-write this file with TSGen types
export var AccountingType;
(function (AccountingType) {
    AccountingType["Acquisition"] = "acquisition";
    AccountingType["FromPurchase"] = "fromPurchase";
    AccountingType["Promotion"] = "promotion";
})(AccountingType || (AccountingType = {}));
export var AmountExtractorEnum;
(function (AmountExtractorEnum) {
    AmountExtractorEnum["GrandTotal"] = "GrandTotal";
    AmountExtractorEnum["ExpectedRevenue"] = "ExpectedRevenue";
    AmountExtractorEnum["GrossBookValue"] = "GrossBookValue";
    AmountExtractorEnum["BasePrice"] = "BasePrice";
    AmountExtractorEnum["DailyComparablePriceDifference"] = "DailyComparablePriceDifference";
    AmountExtractorEnum["AncillaryTotal"] = "AncillaryTotal";
    AmountExtractorEnum["PreDiscountTotal"] = "PreDiscountTotal";
    AmountExtractorEnum["ComparablePriceDifference"] = "ComparablePriceDifference";
    AmountExtractorEnum["PreDiscountGrandTotal"] = "PreDiscountGrandTotal";
    AmountExtractorEnum["SellPrice"] = "SellPrice";
})(AmountExtractorEnum || (AmountExtractorEnum = {}));
export var ApplicabilityEnum;
(function (ApplicabilityEnum) {
    ApplicabilityEnum["NoFlightPurchaseHistory"] = "NoFlightPurchaseHistory";
    ApplicabilityEnum["ProductWithDestination"] = "ProductWithDestination";
    ApplicabilityEnum["HasComparable"] = "HasComparable";
    ApplicabilityEnum["NoCarRentalHistory"] = "NoCarRentalHistory";
    ApplicabilityEnum["Always"] = "Always";
    ApplicabilityEnum["FirstFlightBookingThisMonth"] = "FirstFlightBookingThisMonth";
    ApplicabilityEnum["FirstReservation"] = "FirstReservation";
    ApplicabilityEnum["UserCountry"] = "UserCountry";
    ApplicabilityEnum["IntegerComparison"] = "IntegerComparison";
    ApplicabilityEnum["And"] = "And";
    ApplicabilityEnum["IsGround"] = "IsGround";
    ApplicabilityEnum["ProductGeoLocation"] = "ProductGeoLocation";
    ApplicabilityEnum["NoLodgingPurchaseHistory"] = "NoLodgingPurchaseHistory";
    ApplicabilityEnum["PurchaseCurrency"] = "PurchaseCurrency";
    ApplicabilityEnum["IsAir"] = "IsAir";
    ApplicabilityEnum["LodgingIds"] = "LodgingIds";
    ApplicabilityEnum["FirstWebLodgingReservation"] = "FirstWebLodgingReservation";
    ApplicabilityEnum["FirstFlightBooking"] = "FirstFlightBooking";
    ApplicabilityEnum["FirstReservationThisMonth"] = "FirstReservationThisMonth";
    ApplicabilityEnum["Never"] = "Never";
    ApplicabilityEnum["AmountPositive"] = "AmountPositive";
    ApplicabilityEnum["FirstCarRental"] = "FirstCarRental";
    ApplicabilityEnum["ProductWithOrigin"] = "ProductWithOrigin";
    ApplicabilityEnum["HopperCanDiscount"] = "HopperCanDiscount";
    ApplicabilityEnum["Airline"] = "Airline";
    ApplicabilityEnum["AmountComparison"] = "AmountComparison";
    ApplicabilityEnum["IsPreferred"] = "IsPreferred";
    ApplicabilityEnum["RequiresCreditCard"] = "RequiresCreditCard";
    ApplicabilityEnum["Or"] = "Or";
    ApplicabilityEnum["IsLodging"] = "IsLodging";
    ApplicabilityEnum["IsHomes"] = "IsHomes";
    ApplicabilityEnum["HomeIds"] = "HomeIds";
    ApplicabilityEnum["FirstHomesBooking"] = "FirstHomesBooking";
    ApplicabilityEnum["Not"] = "Not";
})(ApplicabilityEnum || (ApplicabilityEnum = {}));
export var PersonalOfferStateEnum;
(function (PersonalOfferStateEnum) {
    PersonalOfferStateEnum["Used"] = "Used";
    PersonalOfferStateEnum["ConfirmState"] = "ConfirmState";
    PersonalOfferStateEnum["Cancelled"] = "Cancelled";
    PersonalOfferStateEnum["Expired"] = "Expired";
    PersonalOfferStateEnum["Pending"] = "Pending";
    PersonalOfferStateEnum["Authorized"] = "Authorized";
})(PersonalOfferStateEnum || (PersonalOfferStateEnum = {}));
export var AvailableProductEnum;
(function (AvailableProductEnum) {
    AvailableProductEnum["Air"] = "Air";
    AvailableProductEnum["CarRental"] = "CarRental";
    AvailableProductEnum["Lodging"] = "Lodging";
    AvailableProductEnum["Home"] = "Home";
    AvailableProductEnum["Activity"] = "Activity";
})(AvailableProductEnum || (AvailableProductEnum = {}));
export var CashBackEnum;
(function (CashBackEnum) {
    CashBackEnum["CashBackOffer"] = "CashBackOffer";
    CashBackEnum["CashBackOfferWithDiscount"] = "CashBackOfferWithDiscount";
    CashBackEnum["MultipleCashBackOffers"] = "MultipleCashBackOffers";
})(CashBackEnum || (CashBackEnum = {}));
export var CashBackRulesEnum;
(function (CashBackRulesEnum) {
    CashBackRulesEnum["RevenueRatioCashBack"] = "RevenueRatioCashBack";
    CashBackRulesEnum["FixedCashBack"] = "FixedCashBack";
    CashBackRulesEnum["RatioCashBack"] = "RatioCashBack";
    CashBackRulesEnum["GrandTotalRatioCashBack"] = "GrandTotalRatioCashBack";
    CashBackRulesEnum["SellPriceRatioCashBack"] = "SellPriceRatioCashBack";
})(CashBackRulesEnum || (CashBackRulesEnum = {}));
export var ComparatorEnum;
(function (ComparatorEnum) {
    ComparatorEnum["ControlComparator"] = "ControlComparator";
    ComparatorEnum["ResourceComparator"] = "ResourceComparator";
})(ComparatorEnum || (ComparatorEnum = {}));
export var ConfirmStateEnum;
(function (ConfirmStateEnum) {
    ConfirmStateEnum["Open"] = "Open";
    ConfirmStateEnum["Voided"] = "Voided";
})(ConfirmStateEnum || (ConfirmStateEnum = {}));
export var DiscountedEnum;
(function (DiscountedEnum) {
    DiscountedEnum["CashBackOfferWithDiscount"] = "CashBackOfferWithDiscount";
    DiscountedEnum["Discount"] = "Discount";
})(DiscountedEnum || (DiscountedEnum = {}));
export var IntExtractorEnum;
(function (IntExtractorEnum) {
    IntExtractorEnum["NumNights"] = "NumNights";
    IntExtractorEnum["NumStops"] = "NumStops";
})(IntExtractorEnum || (IntExtractorEnum = {}));
export var LocationKindEnum;
(function (LocationKindEnum) {
    LocationKindEnum["Region"] = "region";
    LocationKindEnum["Airport"] = "airport";
    LocationKindEnum["State"] = "state";
    LocationKindEnum["Country"] = "country";
    LocationKindEnum["City"] = "city";
})(LocationKindEnum || (LocationKindEnum = {}));
export var MerchantOfRecord;
(function (MerchantOfRecord) {
    MerchantOfRecord["Hopper"] = "hopper";
    MerchantOfRecord["Other"] = "other";
})(MerchantOfRecord || (MerchantOfRecord = {}));
export var PaymentSchedule;
(function (PaymentSchedule) {
    PaymentSchedule["PayNow"] = "PayNow";
    PaymentSchedule["PayLater"] = "PayLater";
})(PaymentSchedule || (PaymentSchedule = {}));
export var Funnel;
(function (Funnel) {
    Funnel["Air"] = "Air";
    Funnel["Ground"] = "Ground";
    Funnel["Lodging"] = "Lodging";
    Funnel["Home"] = "Home";
    Funnel["Homes"] = "Homes";
    Funnel["Experiences"] = "Experiences";
    Funnel["Package"] = "Package";
    Funnel["Activity"] = "Activity";
})(Funnel || (Funnel = {}));
export var StatementCreditStandingEnum;
(function (StatementCreditStandingEnum) {
    StatementCreditStandingEnum["EnterGoodStanding"] = "EnterGoodStanding";
    StatementCreditStandingEnum["EnterBadStanding"] = "EnterBadStanding";
    StatementCreditStandingEnum["Other"] = "Other";
    StatementCreditStandingEnum["Unknown"] = "Unknown";
})(StatementCreditStandingEnum || (StatementCreditStandingEnum = {}));
export var StatementCreditDetailStatus;
(function (StatementCreditDetailStatus) {
    StatementCreditDetailStatus["Full"] = "Full";
    StatementCreditDetailStatus["Partial"] = "Partial";
    StatementCreditDetailStatus["Empty"] = "Empty";
})(StatementCreditDetailStatus || (StatementCreditDetailStatus = {}));
export var StatementCreditProductType;
(function (StatementCreditProductType) {
    StatementCreditProductType["VentureX"] = "VentureX";
    StatementCreditProductType["VentureXBusiness"] = "VentureXBusiness";
    StatementCreditProductType["Venture"] = "Venture";
    StatementCreditProductType["VentureBusiness"] = "VentureBusiness";
    StatementCreditProductType["Quicksilver"] = "Quicksilver";
    StatementCreditProductType["Savor"] = "Savor";
    StatementCreditProductType["VentureOne"] = "VentureOne";
    StatementCreditProductType["DiscoverItCashBack"] = "DiscoverItCashBack";
    StatementCreditProductType["DiscoverItMiles"] = "DiscoverItMiles";
    StatementCreditProductType["DiscoverItMore"] = "DiscoverItMore";
    StatementCreditProductType["DiscoverItChrome"] = "DiscoverItChrome";
    StatementCreditProductType["SparkCashPlus"] = "SparkCashPlus";
    StatementCreditProductType["SparkCash"] = "SparkCash";
    StatementCreditProductType["Vesper"] = "Vesper";
})(StatementCreditProductType || (StatementCreditProductType = {}));
export var RestrictedToProductsEnum;
(function (RestrictedToProductsEnum) {
    RestrictedToProductsEnum["Air"] = "Air";
    RestrictedToProductsEnum["Ground"] = "Ground";
    RestrictedToProductsEnum["Lodging"] = "Lodging";
    RestrictedToProductsEnum["Homes"] = "Homes";
    RestrictedToProductsEnum["Packages"] = "Packages";
    RestrictedToProductsEnum["Activities"] = "Activities";
})(RestrictedToProductsEnum || (RestrictedToProductsEnum = {}));
export var CreditTypeEnum;
(function (CreditTypeEnum) {
    CreditTypeEnum["CreditOffer"] = "CREDIT_OFFER";
})(CreditTypeEnum || (CreditTypeEnum = {}));
export var CreditCollectionTypeEnum;
(function (CreditCollectionTypeEnum) {
    CreditCollectionTypeEnum["Premier"] = "Premier";
    CreditCollectionTypeEnum["Lifestyle"] = "Lifestyle";
    CreditCollectionTypeEnum["NoCollection"] = "NoCollection";
})(CreditCollectionTypeEnum || (CreditCollectionTypeEnum = {}));
export var OfferApplicabilityEnum;
(function (OfferApplicabilityEnum) {
    OfferApplicabilityEnum["Applicable"] = "Applicable";
    OfferApplicabilityEnum["NonApplicable"] = "NonApplicable";
})(OfferApplicabilityEnum || (OfferApplicabilityEnum = {}));
export var OfferEnum;
(function (OfferEnum) {
    OfferEnum["CashBackOffer"] = "CashBackOffer";
    OfferEnum["CashBackOfferWithDiscount"] = "CashBackOfferWithDiscount";
    OfferEnum["Discount"] = "Discount";
    OfferEnum["MultipleCashBackOffers"] = "MultipleCashBackOffers";
})(OfferEnum || (OfferEnum = {}));
export var OperatorEnum;
(function (OperatorEnum) {
    OperatorEnum["Gt"] = "Gt";
    OperatorEnum["Gte"] = "Gte";
    OperatorEnum["Lt"] = "Lt";
    OperatorEnum["Lte"] = "Lte";
})(OperatorEnum || (OperatorEnum = {}));
export var ProductApplicability;
(function (ProductApplicability) {
    ProductApplicability["Applicable"] = "applicable";
    ProductApplicability["NonApplicable"] = "nonApplicable";
})(ProductApplicability || (ProductApplicability = {}));
export var ProductClassEnum;
(function (ProductClassEnum) {
    ProductClassEnum["Basic"] = "basic";
    ProductClassEnum["Economy"] = "economy";
    ProductClassEnum["Premium"] = "premium";
})(ProductClassEnum || (ProductClassEnum = {}));
export var RegionTypeEnum;
(function (RegionTypeEnum) {
    RegionTypeEnum["Airport"] = "Airport";
    RegionTypeEnum["City"] = "City";
})(RegionTypeEnum || (RegionTypeEnum = {}));
export var TripType;
(function (TripType) {
    TripType["OneWay"] = "one_way";
    TripType["OpenJaw"] = "open_jaw";
    TripType["RoundTrip"] = "round_trip";
})(TripType || (TripType = {}));
export var TransactionTypeEnum;
(function (TransactionTypeEnum) {
    TransactionTypeEnum["TravelCreditRedemption"] = "TRAVEL_CREDIT_REDEMPTION";
    TransactionTypeEnum["TravelCreditAdjustment"] = "TRAVEL_CREDIT_ADJUSTMENT";
    TransactionTypeEnum["PremierCollectionTravelCredit"] = "PREMIER_COLLECTION_TRAVEL_CREDIT";
    TransactionTypeEnum["StatementCreditCreated"] = "STATEMENT_CREDIT_CREATED";
    TransactionTypeEnum["StatementCreditRedeemed"] = "STATEMENT_CREDIT_REDEEMED";
    TransactionTypeEnum["StatementCreditExpired"] = "STATEMENT_CREDIT_EXPIRED";
    TransactionTypeEnum["StatementCreditCanceled"] = "STATEMENT_CREDIT_CANCELED";
    TransactionTypeEnum["PriceDropProtection"] = "PRICE_DROP_PROTECTION";
    TransactionTypeEnum["TravelOffer"] = "TRAVEL_OFFER";
    TransactionTypeEnum["PriceMatch"] = "PRICE_MATCH";
    TransactionTypeEnum["Refund"] = "REFUND";
    TransactionTypeEnum["PendingTravelCredit"] = "PENDING_TRAVEL_CREDIT";
    TransactionTypeEnum["Expired"] = "EXPIRED";
    TransactionTypeEnum["Canceled"] = "CANCELED";
    TransactionTypeEnum["ReferralCredit"] = "REFERRAL_CREDIT";
    TransactionTypeEnum["HotelsFlightsBusinessOfferCredit"] = "HOTELS_FLIGHTS_BUSINESS_OFFER_CREDIT";
    TransactionTypeEnum["SpendAndGetCredit"] = "SPEND_AND_GET_CREDIT";
    TransactionTypeEnum["SpendAndGetCreditCanceled"] = "SPEND_AND_GET_CREDIT_CANCELLED";
    TransactionTypeEnum["FirstTimeBookerCredit"] = "FIRST_TIME_BOOKER_OFFER_CREDIT";
    TransactionTypeEnum["BusinessTravelLtoCredit"] = "BUSINESS_TRAVEL_LTO_CREDIT";
})(TransactionTypeEnum || (TransactionTypeEnum = {}));
export var TransactionReasonCode;
(function (TransactionReasonCode) {
    TransactionReasonCode["NEW_ACCOUNT_OPENING"] = "NEW_ACCOUNT_OPENING";
    TransactionReasonCode["START_NEW_BENEFIT_PERIOD"] = "START_NEW_BENEFIT_PERIOD";
    TransactionReasonCode["ENTER_BAD_STANDING"] = "ENTER_BAD_STANDING";
    TransactionReasonCode["ENTER_GOOD_STANDING"] = "ENTER_GOOD_STANDING";
    TransactionReasonCode["ACCOUNT_UPGRADE"] = "ACCOUNT_UPGRADE";
    TransactionReasonCode["ACCOUNT_DOWNGRADE"] = "ACCOUNT_DOWNGRADE";
    TransactionReasonCode["ACCOUNT_MIGRATED"] = "ACCOUNT_MIGRATED";
})(TransactionReasonCode || (TransactionReasonCode = {}));
export var PartialCreditHistoryResponseEnum;
(function (PartialCreditHistoryResponseEnum) {
    PartialCreditHistoryResponseEnum["Failure"] = "Failure";
    PartialCreditHistoryResponseEnum["NotAttempted"] = "NotAttempted";
    PartialCreditHistoryResponseEnum["Success"] = "Success";
})(PartialCreditHistoryResponseEnum || (PartialCreditHistoryResponseEnum = {}));
export var ProcessInsightsResultEnum;
(function (ProcessInsightsResultEnum) {
    ProcessInsightsResultEnum["Failure"] = "Failure";
    ProcessInsightsResultEnum["ProfileNotFound"] = "ProfileNotFound";
    ProcessInsightsResultEnum["Success"] = "Success";
    ProcessInsightsResultEnum["Unauthorized"] = "Unauthorized";
    ProcessInsightsResultEnum["Unknown"] = "Unknown";
})(ProcessInsightsResultEnum || (ProcessInsightsResultEnum = {}));
//# sourceMappingURL=wallet.js.map